/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type PatchContractProposalPensionSavingBodyInvestmentToolType =
  (typeof PatchContractProposalPensionSavingBodyInvestmentToolType)[keyof typeof PatchContractProposalPensionSavingBodyInvestmentToolType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PatchContractProposalPensionSavingBodyInvestmentToolType = {
  pension_saving: "pension_saving",
} as const;
